import React, {useEffect, useState} from 'react'
import { getCurrentUser } from '../utils/auth'
import {format} from 'date-fns'
import "./Facilities.css"
import { useNavigate } from "react-router-dom"
import { BsFillPencilFill, BsFillTrashFill, BsFileTextFill, BsTable } from 'react-icons/bs'
import ModalFacilityEdit from "./ModalFacilityEdit"
import ModalFacilitySessions from './ModalFacilitySessions'
import ModalFacilityNotes from './ModalFacilityNotes'
import Caret from './Icon/Caret'
import { Link } from 'react-router-dom'

const Facilities = ({deleteRow}) => {
    const tokenPayload = getCurrentUser() || {};
    const userScopes = tokenPayload.scopes || [];
    const navigate = useNavigate();
    const permissionScope = 'facilityData'
    const tokenCustomerId = tokenPayload?.customer ?? tokenPayload?.customer_id;
    const hasGlobalReadPermission = userScopes.includes('read:' + permissionScope);
    const hasCustomerScopedReadPermission = userScopes.some((scope) => scope.startsWith('read:' + permissionScope + 'Customer'));
    const hasReadPermission = hasGlobalReadPermission || hasCustomerScopedReadPermission;
    const shouldFilterByCustomer = Boolean(tokenCustomerId !== undefined && tokenCustomerId !== null && hasCustomerScopedReadPermission && !hasGlobalReadPermission);
    const fetchAllFacilitiesUrl = process.env.REACT_APP_API_URL_BASE + '/facilities/view'
    const fetchCustomerFacilitiesUrl = process.env.REACT_APP_API_URL_BASE + '/facilities/customer/*id*/view'
    const fetchSingleFacilityUrl = process.env.REACT_APP_API_URL_BASE + '/facilities/facility/*id*/view'
    const fieldsNoSort = ["Info", "Active", "Authorized", "Actions"]
    const headers = [
        {
            id: 0,
            KEY: "info",
            LABEL: "Info",
            CLASS: "icons-width"
        },
        {
            id: 1,
            KEY: "facility_id",
            LABEL: "ID",
            CLASS: "left"
        },
        {
            id: 2,
            KEY: "facility_name",
            LABEL: "Facility",
            CLASS: "left"
        },
        {
            id: 3,
            KEY: "description",
            LABEL: "Type",
            CLASS: "left"
        },
        {
            id: 4,
            KEY: "customer_name",
            LABEL: "Customer",
            CLASS: "left"
        },
        {
            id: 5,
            KEY: "is_authorized",
            LABEL: "Authorized",
            CLASS: ""
        },
        {
            id: 7,
            KEY: "created_on",
            LABEL: "Facility Since",
            CLASS: "left"
        },
        {
            id: 8,
            KEY: "actions",
            LABEL: "Actions",
            CLASS: "left"
        }
    ]

    const [facilityEdit, setFacilityEdit] = useState(null);
    const [facilityIdSessions, setFacilityIdSessions] = useState(null);
    const [facilityInfo, setFacilityInfo] = useState(null);
    const [allFacilityTypes, setAllFacilityTypes] = useState(null);
    const [allCustomers, setAllCustomers] = useState([]);
    const [editedRecord, setEditedRecord] = useState(null);
    const [isNewFacility, setIsNewFacility] = useState(false);
    const [modalNotes, setModalNotes] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);
    const [modalSessions, setModalSessions] = useState(false);
    const [sessionCount] = useState(0);
    const [podCount] = useState(0);
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [showUnauthorized, setShowUnauthorized] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState({ keyToSort: "facility_name", direction: "asc"});

    const normalizedSearchText = searchText.trim().toLowerCase();

    const matchesSearch = (record) => {
        if (!normalizedSearchText) {
            return true;
        }

        const searchableValues = [
            record.id,
            record.facility_name,
            record.description,
            record.customer_name,
        ];

        return searchableValues
            .filter((value) => value !== null && value !== undefined)
            .some((value) => String(value).toLowerCase().includes(normalizedSearchText));
    };

    const visibleRecords = records
        .map((record, recordIndex) => ({ record, recordIndex }))
        .filter(({ record }) => (showUnauthorized || record.is_authorized !== false) && matchesSearch(record));


    const fetchAllFacilityData = async () => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchAllFacilitiesUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchCustomerFacilityData = async (customer_id) => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchCustomerFacilitiesUrl.replace("*id*", customer_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchSingleFacilityData = async (facility_id) => {
        try{
            const response = await fetch(fetchSingleFacilityUrl.replace("*id*", facility_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(originalRecords => {
                const newRecords = [...originalRecords];
                newRecords[editedRecord] = json[0];
                return newRecords;
            });
        } catch (error) {
            console.error(error);
        }
    }

    const fetchAllFacilityTypes = async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/facility_types/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const musicOptions = data.map(item => ({ description: item.description, id: item.facility_type_id }));
            setAllFacilityTypes(musicOptions)
        })
        .catch(error => console.error(error));
    }

    const fetchAllCustomers = async () => {
            fetch(process.env.REACT_APP_API_URL_BASE + '/customers/',
            {
                method: 'GET',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                },
            })
            .then(res => res.json())
            .then(data => {
                const formattedCustomers = data.map(item => ({ customer_name: item.customer_name, id: item.customer_id }));
                setAllCustomers(formattedCustomers)
            })
            .catch(error => console.error(error));
        }

    useEffect(() => {
        if (!window.sessionStorage.getItem("auth") || !hasReadPermission) {
            navigate('/unauthorized')
        }

        if (editedRecord !== null) {
            fetchSingleFacilityData(records[editedRecord].id);
            setEditedRecord(null)
        }
        else {
            if (shouldFilterByCustomer) {
                //pull only facilities attached to this users customer ID
                fetchCustomerFacilityData(tokenCustomerId);
            }
            else {
                // pull all Facilities
                fetchAllFacilityData();
            }
        }
        fetchAllFacilityTypes();
        fetchAllCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleHeaderClick(header) {
        if (!fieldsNoSort.includes(header.LABEL)) {
            const nextDirection =
                header.KEY === sort.keyToSort
                    ? (sort.direction === 'asc' ? 'desc' : 'asc')
                    : 'asc';

            const nextSort = {
                keyToSort: header.KEY,
                direction: nextDirection,
            };

            setSort(nextSort);
            setRecords((originalRecords) => {
                const sortedData = [...originalRecords].sort((a, b) => {
                    const aValue = a[nextSort.keyToSort];
                    const bValue = b[nextSort.keyToSort];

                    if (aValue === null || aValue === undefined) return 1;
                    if (bValue === null || bValue === undefined) return -1;

                    const aComparable = String(aValue).toLowerCase();
                    const bComparable = String(bValue).toLowerCase();

                    if (nextSort.direction === 'asc') {
                        return aComparable.localeCompare(bComparable);
                    }

                    return bComparable.localeCompare(aComparable);
                });

                return sortedData;
            });
        }
    }

    const handleFacilityEdit = (facilityInfo, recordIndex) => {
        // edit facility info icon clicked
        // set the record in order to do a refresh on the edited facility
        // console.log("Editing Facility: ", facilityInfo);
        // console.log("Record Index: ", recordIndex);
        setEditedRecord(recordIndex)
        setFacilityEdit(facilityInfo)
        setIsNewFacility(false);
        setIsReadOnlyModal(false);
        setModalEdit(true);
      };

    const handleFacilityView = (facilityInfo, event) => {
        if (event.target.closest('.actions-cell') || event.target.closest('.info-cell')) {
            return;
        }

        setFacilityEdit(facilityInfo);
        setIsNewFacility(false);
        setIsReadOnlyModal(true);
        setModalEdit(true);
    };

    const handleViewSessions = (facilityInfo) => {
        // View Sessions icon clicked
        setIsNewFacility(false);
        setFacilityInfo(facilityInfo);
        setFacilityIdSessions(facilityInfo.id);
        setModalSessions(true);
    }

    const handleViewNotes = (facilityInfo) => {
        // Notes icon clicked
        setIsNewFacility(false);
        setFacilityInfo(facilityInfo);
        setModalNotes(true);
    }

    const handleDeleteFacility = async (facilityInfo, recordIndex) => {
        // Delete icon clicked: set facility unauthorized
        if (canDeleteRecords) {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/facilities/facility/' + facilityInfo.id,
                    {
                        method: 'PATCH',
                        headers: {
                            'machine':'2',
                            'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            is_authorized: false
                        }),
                    });

                if (!response.ok) {
                    throw new Error(`Failed to set facility unauthorized. Status: ${response.status}`);
                }

                setRecords((originalRecords) => originalRecords.map((record, index) => {
                    if (index !== recordIndex) {
                        return record;
                    }

                    return {
                        ...record,
                        is_authorized: false,
                    };
                }));
            } catch (error) {
                console.error(error);
            }
        }
    }

    const handleNewFacility = () => {
        // new facility button clicked - create a generic empty facility object
        const newFacility = {
                'facility_name': '',
                'facility_type': 1,
                'is_authorized': true,
                'config': {},
                'customer': 99
            };
        setFacilityEdit(newFacility);
        setIsNewFacility(true);
        setModalEdit(true);
      }

    const handleEditSubmit = (newRow) => {
        if (isNewFacility) {
            // pull all data - refresh page
            window.location.reload()
            setIsNewFacility(false)
        }
        else {
            // edited existing facility - update specific row
            fetchSingleFacilityData(records[editedRecord].id)
            setEditedRecord(null)
        }
      }

    const handleNotesSubmit = () => {
        //  handle any necessary logic after a new has been added
    }

    const showDelete = (record, recordIndex) => {
        // if the user has delete scope then show the delete icon
        if (canDeleteRecords) {
            return <BsFillTrashFill onClick={() => handleDeleteFacility(record, recordIndex)} className='delete-btn' title='Deauthorize this Facility' aria-label='Deauthorize this Facility'/>
        }
    }

    const showEdit = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditRecords) {
            return <BsFillPencilFill onClick={() => handleFacilityEdit(record,recordIndex)} className='edit-btn' title='Edit Facility' aria-label='Edit Facility'/>
        }
    }

    const hasNotesPermission = (tokenPayload.scopes || []).some((scope) =>
        scope.startsWith('create:facilityNotes') || scope.startsWith('update:facilityNotes')
    );

    const canDeleteRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('delete:' + permissionScope));

    const canEditRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('update:' + permissionScope)) ||
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope));

    const canShowAnyActions = canDeleteRecords || canEditRecords;
    const visibleHeaders = canShowAnyActions ? headers : headers.filter((header) => header.KEY !== 'actions');
    const canShowUnauthorizedToggle = canDeleteRecords;

    const showCreateNew = () => {
        // if the user has create scope then show the Add New Facility button
        if ((tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope))) {
            return (
                <Link className='btn facilities-add-btn' onClick={() => handleNewFacility()}>+ Add New Facility</Link>
            )
        }
    }

    function showDebug() {
        // var debugString = 'Sort Direction: ' + sort.direction + ' Sort Field: ' + sort.keyToSort;
        // // var debugString = sort.keyToSort === 'last_name' ? sort.direction : "asc"
        // return debugString
    }

    return (
        <div className='table-wrapper facilities-page'>
            {/*<h3 className='left'>&emsp;&ensp;Facilities{facilityInfo !== null ? ": " + facilityInfo.facility_name : ""} ({records.length})</h3>*/}
            <h3 className='page-title'>
                Facilities <span className='page-count'>{visibleRecords.length}</span>
            </h3>
            <div>
                {showDebug()}
            </div>
            <div>
                {showCreateNew()}
            </div>
            <div className='facilities-filter'>
                <div className='table-search-input-wrap'>
                    <input
                        type='text'
                        className='facilities-search-input table-search-input'
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        placeholder='Search facilities'
                        aria-label='Search facilities'
                    />
                    <button
                        type='button'
                        className='table-search-clear-icon'
                        onClick={() => setSearchText('')}
                        disabled={!searchText}
                        aria-label='Clear facility search'
                    >
                        x
                    </button>
                </div>
                {canShowUnauthorizedToggle && (
                    <label className='facilities-filter-label'>
                        <input
                            type='checkbox'
                            checked={showUnauthorized}
                            onChange={(event) => setShowUnauthorized(event.target.checked)}
                        />
                        Show Unauthorized
                    </label>
                )}
            </div>
            <font size="3">
            <table className='table'>
                <thead>
                    <tr>
                        {visibleHeaders.map((header, index) => (
                            <th key={index} className={header.CLASS} onClick={() => handleHeaderClick(header)}>
                                {header.LABEL}
                                {header.KEY === sort.keyToSort && (
                                <Caret direction={sort.keyToSort === header.KEY ? sort.direction : "asc"}/>)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        isTableLoading ? (
                            Array.from({ length: 6 }).map((_, rowIndex) => (
                                <tr key={`facilities-skeleton-${rowIndex}`} className='table-skeleton-row'>
                                    {visibleHeaders.map((header, cellIndex) => (
                                        <td key={`facilities-skeleton-${rowIndex}-${header.KEY}-${cellIndex}`}>
                                            <span className={`table-skeleton-line${header.KEY === 'info' || header.KEY === 'actions' ? ' short' : ''}`} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            visibleRecords.map(({ record, recordIndex }) => {
                                return <tr key={recordIndex} onClick={(event) => handleFacilityView(record, event)}>
                                <td className='info-cell'>
                                    <span className='actions'>
                                        {hasNotesPermission && (
                                            <BsFileTextFill onClick={(event) => { event.stopPropagation(); handleViewNotes(record); }} className='sessions-btn' title='Facility Notes' aria-label='Facility Notes'/>
                                        )}
                                        <BsTable onClick={(event) => { event.stopPropagation(); handleViewSessions(record); }} className='sessions-btn' title='Show Session History' aria-label='Show Session History'/>
                                    </span>
                                </td>
                                <td className='left'>{record.id}</td>
                                <td className='left'>{record.facility_name}</td>
                                <td className='left'>{record.description}</td>
                                <td className='left'>{record.customer_name}</td>
                                <td className='center'>{record.is_authorized ? "\u2714" : ""}</td>
                                <td className='left'>{record.created_on ? format(new Date(record.created_on), 'MMM d, yyyy') : ''}</td>
                                {canShowAnyActions && (
                                    <td className='actions-cell'>
                                        <span className='actions'>
                                            {showEdit(record, recordIndex)}
                                            {showDelete(record, recordIndex)}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            })
                        )}
                </tbody>
            </table>
            </font>
            {modalSessions && <ModalFacilitySessions closeModal={() => {
                setModalSessions(false)
            }}
                facilityIdSessions={facilityIdSessions}
                facilityInfo={facilityInfo}
                sessionCount={sessionCount}
                podCount={podCount}
            />}
            {modalEdit && <ModalFacilityEdit closeModal={() => {
                setModalEdit(false)
                setIsReadOnlyModal(false)
            }}
                onSubmit={handleEditSubmit}
                facilityEdit={facilityEdit}
                isNewFacility={isNewFacility}
                allFacilityTypes={allFacilityTypes}
                allCustomers={allCustomers}
                isReadOnly={isReadOnlyModal}
            />}
            {modalNotes && <ModalFacilityNotes closeModal={() => {
                setModalNotes(false)
            }}
                onSubmit={handleNotesSubmit}
                facilityInfo={facilityInfo}
                isNewFacility={isNewFacility}
            />}
        </div>
  )
}

export default Facilities



